import React from "react";

function AlertBanner({
  title,
  message,
  variant = "warning", // 'warning', 'info', etc.
  actionButton, // Accepts a React element like <button> or <a>
  style = {},
}) {
  return (
    <div className={`${variant}-alert-container`} style={style}>
      <p className={variant} style={{ margin: 0, flex: 1 }}>
        {title && <strong>{title} </strong>}
        {message}
      </p>
      {actionButton && (
        <div className="alert-action-wrapper">{actionButton}</div>
      )}
    </div>
  );
}

export default AlertBanner;
